import {Component, OnInit} from '@angular/core';
import {CreateFormsInterface, ItemForm} from './models/create-forms.interface';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {INPUT_TYPES, PROVIDERS, TYPE_FILES} from './mocks/create-forms.mocks';

@Component({
  selector: 'app-create-forms',
  templateUrl: './create-forms.page.html',
  styleUrls: ['../app.component.scss'],
})
export class CreateFormsPage implements OnInit {
  showForm = false;
  formInfo: CreateFormsInterface[] = [];
  createForm: FormGroup;
  sectionTitle = '';
  orderOptions = [];
  providers = PROVIDERS;
  inputTypes = INPUT_TYPES;
  typeFiles = TYPE_FILES;
  sectionSelected: any;

  constructor() {
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.createForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.maxLength(30)]),
      type: new FormControl('', [Validators.required]),
      minLength: new FormControl(''),
      maxLength: new FormControl(''),
      itemDropdown: new FormControl(false),
      previousDate: new FormControl(false),
      laterDate: new FormControl(''),
      order: new FormControl('', [Validators.required]),
      mandatory: new FormControl(false, [Validators.required]),
      copyPaste: new FormControl(false, [Validators.required]),
      googleMaps: new FormControl(false, [Validators.required]),
      typeFile: new FormControl(''),
    });
  }

  createSection() {
    if (this.sectionTitle) {
      this.formInfo.push({ nameSection: this.sectionTitle, items: [] });
      this.sectionSelected = this.sectionTitle;
      this.sectionTitle = '';
      this.calculateOrderOptions();
    }
  }

  calculateOrderOptions() {
    const items = this.formInfo.find(section => section.nameSection === this.sectionSelected);
    if(items){
      this.orderOptions = items.items.length > 0 ? Array.from({ length: items.items.length+1 }, (_, i) => i + 1) : [1];
    }
  }

  print() {
    if (this.createForm.valid) {
      const input: ItemForm = {
        name: this.createForm.value.name,
        type: this.createForm.value.type,
        minlength: this.createForm.value.minlength,
        maxlength: this.createForm.value.maxlength,
        itemDropdown: this.createForm.value.itemDropdown,
        previousDate: this.createForm.value.previousDate,
        laterDate: this.createForm.value.laterDate,
        order: this.createForm.value.order,
        mandatory: this.createForm.value.mandatory,
        copyPaste: this.createForm.value.copyPaste,
        googleMaps: this.createForm.value.googleMaps,
        typeFile: this.createForm.value.typeFile,
      };

      const sectionItems = this.formInfo.find(item => item.nameSection === this.sectionSelected);

      if (sectionItems) {
        sectionItems.items = sectionItems.items || [];
        sectionItems.items.push(input);
        this.calculateOrderOptions();
        console.log(this.formInfo);
      }
    }
  }
}
